module.exports = __webpack_public_path__ + "static/media/sn-min.e6a15ba8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/sn-min.svg
// module id = 693
// module chunks = 0